import _ from 'underscore';
import { COUNTRIES } from './countries';
/**
 * Checks if the given query is within the list 'countriesAndRegions'
 * @param {Array} supportedMarkets - countries or regions supported in lowercase
 * @param {string} query
 * @returns {boolean} - if the query is or not a unsupported country or region
 */

export const isUnsupportedCountryOrRegion = (supportedMarkets, query) => {
  if (_.isEmpty(query) || query.length < 4) {
    return false;
  }

  const lowerCaseQuery = query.toLowerCase();
  if (_.indexOf(supportedMarkets, lowerCaseQuery) >= 0) {
    return false;
  }

  return _.has(COUNTRIES, lowerCaseQuery);
};

